__turbopack_context__.v({
  "container": "S6TEOW_container",
  "switcher": "S6TEOW_switcher",
  "systemSwitcher": "S6TEOW_systemSwitcher",
});
